import {Component, inject, OnDestroy} from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { Router } from '@angular/router';

export interface PromptModalData {
    title?: string;
    message?: string;
    okButtonLabel?: string;
    cancelButtonLabel?: string;
    onOkCallback?: () => void;
    onCancelCallback?: () => void;
    onCloseCallback?: () => void;
}

@Component({
    selector: 'app-prompt-modal',
    standalone: true,
    imports: [],
    templateUrl: './prompt-modal.component.html',
})
export class PromptModalComponent implements PromptModalData, OnDestroy {
    #modalService = inject(ModalService);
    #router = inject(Router);

    title?: string;
    message?: string;
    okButtonLabel?: string;
    cancelButtonLabel?: string;
    onOkCallback?: () => void;
    onCancelCallback?: () => void;
    onCloseCallback?: () => void;

    okClicked = false;

    constructor() {}

    onOk() {
        this.okClicked = true;
        if (this.onOkCallback) this.onOkCallback();
        this.#modalService.close();
    }

    onCancel() {
        if (this.onCancelCallback) this.onCancelCallback();
        this.#modalService.close();
    }

    ngOnDestroy(): void {
        if (!this.okClicked && this.onCancelCallback) this.onCancelCallback();
        if (this.onCloseCallback) this.onCloseCallback();
    }
}
